import {useContext} from 'react';

import {CompanySecuritySettings, TwoFactorAuthenticationSettings} from '../types/securitySettings';

import {UserContext} from '../../../../contexts/UserContext/UserContext';
import {useApiRead} from '../../../../hooks/useApiRead';
import {GetRoutes} from '../../../../lib/api/GET/GetRoutes';
import {CompanyAdminRoleData} from '../../../../types/User';

const EMPTY_TWO_FACTOR: TwoFactorAuthenticationSettings = {enabled: false, enforced: false};

/**
 *
 * Loads the company security settings used by the Company Settings 2FA panel and the personal
 * toggle (to know whether the company enforces 2FA). Company-admin only on the backend.
 */
export const useCompanySecuritySettings = () => {
  const {currentUser} = useContext(UserContext);
  const companyId = (currentUser?.role.data as CompanyAdminRoleData | undefined)?.companyId;

  const query = useApiRead<CompanySecuritySettings>({
    path: GetRoutes.companySecuritySettings(companyId ?? ''),
    options: {
      queryKey: ['company-security-settings', companyId],
      enabled: !!companyId,
      refetchOnWindowFocus: false,
    },
  });

  const twoFactor = query.data?.securitySettings.twoFactorAuthentication ?? EMPTY_TWO_FACTOR;

  return {
    ...query,
    twoFactor,
    companyId,
  };
};
